var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.193,
    height: 65.517,
    viewBox: "0 0 51.193 65.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12965",
    d: "M50.619 20.312v44.7H1.426V1.5H31.67",
    style: {
      strokeMiterlimit: 6.2,
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(-.426 -.499)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12966",
    d: "M46.93 20.962H28.635a.651.651 0 0 1-.655-.65V2.149a.651.651 0 0 1 .655-.65l18.95 18.813a.651.651 0 0 1-.655.65z",
    transform: "translate(2.609 -.499)",
    style: {
      stroke: "#333",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12967",
    d: "M11.117 38.734h28.445",
    transform: "translate(.681 3.756)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12968",
    d: "M11.117 29.354h28.445",
    transform: "translate(.681 2.684)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12969",
    d: "M11.117 48.115h28.445",
    transform: "translate(.681 4.828)",
    style: {
      stroke: "#d24350",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDocuments);
export default __webpack_public_path__ + "static/media/share-documents.8d7b386ac10548b19391f7d99e52e6ad.svg";
export { ForwardRef as ReactComponent };